import {
  animations,
  emotionStyled,
  hideOutlineAtom,
  reducedMotionAtom,
} from '@packages/utilities/styled';
import {View} from '../../View';

export const ModalContentView = emotionStyled(View)(
  {
    opacity: 0,
    /**
     * Layout work-around that allows for the margin-top and margin-bottom
     * of the inner card to work during layout overflows.
     */
    padding: 1,
    transitionDelay: animations.stagger0,
    willChange: 'opacity, transform',
    '&:focus': {
      outline: 'none',
    },
  },
  {
    variants: {
      applyDefaultPositioning: {
        true: {
          marginBottom: '5vh',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: '5vh',
        },
      },
      isCentered: {
        true: {
          margin: 'auto',
        },
      },
      isFullHeight: {
        true: {
          padding: 0,
          marginTop: 0,
          marginBottom: 0,
          marginLeft: 'auto',
          marginRight: 'auto',
        },
      },
    },
    composes: [hideOutlineAtom, reducedMotionAtom],
  }
);
